import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "brg-input-section month-picker-activator-with-icon" };
const _hoisted_3 = { class: "brg-color-grey-800 text-subtitle-2" };
const _hoisted_4 = { class: "brg-input-section multi-time-picker" };
const _hoisted_5 = { class: "brg-color-grey-800 text-subtitle-2" };
const _hoisted_6 = { class: "right-filter-section" };
import { computed } from 'vue';
import { i18n } from '@/locales';
import { format } from 'date-fns';
import { workerMonthlyAttendanceUseYnTypeOptionList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceUseYnTypeOptionList';
import { workerMonthlyAttendanceSearchTypeOptionList } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceSearchTypeOptionList';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import dateFormatType from '@/constants/dateFormatType';
import vuexStore from '@/vuex-store';
const lc = 'views.worker.worker_monthly_attendance.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const locale = {
            pageTitle: i18n.t(`${lc}page_title`),
            selectPeriod: i18n.t(`${lc}select_period`),
            timeRange: i18n.t(`${lc}time_range`),
            workerUseYn: i18n.t(`${lc}worker_use_yn`),
            searchPlaceholder: i18n.t('common.input_field_placeholder', {
                field: i18n.t('common.search_word'),
            }),
            reset: i18n.t('common.reset'),
        };
        // 조회 기간
        const today = new Date();
        const selectedMonthFormat = dateFormatType.MONTH;
        const maxMonth = format(today, selectedMonthFormat);
        const selectedMonth = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.yearMonth);
        const handleChangeMonthSelector = (value) => {
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', {
                yearMonth: value,
            });
        };
        // 시간 범위
        const selectedTimeRangeFormat = dateFormatType.SHORT_TIME;
        const fromTimePeriod = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.fromTimePeriod);
        const toTimePeriod = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.toTimePeriod);
        const selectedTimeRange = computed(() => {
            const startTimeSuffix = '00';
            const endTimeSuffix = '59';
            return [
                `${fromTimePeriod.value}:${startTimeSuffix}`,
                `${toTimePeriod.value}:${endTimeSuffix}`,
            ];
        });
        const formattedTimeRange = computed(() => selectedTimeRange.value.join(' ~ '));
        const handleChangeTimeRangeSelector = (value) => {
            // API 요청에는 HH만 사용한다.
            const period = value.map((time) => time.split(':')[0]);
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', {
                fromTimePeriod: period[0],
                toTimePeriod: period[1],
            });
        };
        // 라이더 상태
        const workerUseYn = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.workerUseYn);
        const handleChangeUseYnSelector = (value) => {
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', {
                workerUseYn: value,
            });
        };
        // 검색 타입
        const searchType = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.searchType);
        const handleChangeSearchTypeSelector = (value) => {
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', {
                searchType: value,
            });
        };
        // 검색어
        const searchKey = computed(() => vuexStore.state.workerMonthlyAttendance.filterOption.searchKey);
        const handleChangeSearchKeyInput = (value) => {
            vuexStore.dispatch('workerMonthlyAttendance/setFilterOption', {
                searchKey: value,
            });
        };
        /**
         * 초기화 버튼 클릭 핸들러
         */
        const handleClickResetBtn = () => {
            vuexStore.dispatch('workerMonthlyAttendance/resetStore');
        };
        return (_ctx, _cache) => {
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 조회 기간 "),
                        _createElementVNode("div", null, [
                            _createVNode(_component_vue_datepicker, {
                                modelValue: selectedMonth.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((selectedMonth).value = $event)),
                                    handleChangeMonthSelector
                                ],
                                "month-picker": "",
                                position: "left",
                                format: _unref(selectedMonthFormat),
                                "model-type": _unref(selectedMonthFormat),
                                "max-date": _unref(maxMonth)
                            }, {
                                "action-row": _withCtx((props) => [
                                    _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "display-format": _unref(selectedMonthFormat) }), null, 16 /* FULL_PROPS */, ["display-format"])
                                ]),
                                "dp-input": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(locale.selectPeriod), 1 /* TEXT */),
                                        _createVNode(_component_v_text_field, {
                                            value: selectedMonth.value,
                                            variant: "outlined",
                                            density: "compact",
                                            readonly: "",
                                            "hide-details": "",
                                            class: "mt-1",
                                            "bg-color": "white",
                                            "prepend-inner-icon": "mdi-calendar-month-outline"
                                        }, null, 8 /* PROPS */, ["value"])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "format", "model-type", "max-date"])
                        ]),
                        _createCommentVNode(" 시간 범위 "),
                        _createElementVNode("div", null, [
                            _createVNode(_component_vue_datepicker, {
                                ui: { menu: 'hour-only-picker' },
                                modelValue: selectedTimeRange.value,
                                "onUpdate:modelValue": [
                                    _cache[1] || (_cache[1] = ($event) => ((selectedTimeRange).value = $event)),
                                    handleChangeTimeRangeSelector
                                ],
                                "time-picker": "",
                                "no-minutes-overlay": "",
                                "minutes-increment": "60",
                                range: {
                                    disableTimeRangeValidation: true,
                                },
                                position: "left",
                                format: _unref(selectedTimeRangeFormat),
                                "model-type": _unref(selectedTimeRangeFormat)
                            }, {
                                "action-row": _withCtx((props) => [
                                    _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "display-format": _unref(selectedTimeRangeFormat) }), null, 16 /* FULL_PROPS */, ["display-format"])
                                ]),
                                "dp-input": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(locale.timeRange), 1 /* TEXT */),
                                        _createVNode(_component_v_text_field, {
                                            value: formattedTimeRange.value,
                                            variant: "outlined",
                                            density: "compact",
                                            readonly: "",
                                            "hide-details": "",
                                            class: "mt-1",
                                            "bg-color": "white",
                                            "prepend-inner-icon": "mdi-clock-outline"
                                        }, null, 8 /* PROPS */, ["value"])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "format", "model-type"])
                        ]),
                        _createCommentVNode(" 라이더 상태 "),
                        _createElementVNode("div", null, [
                            _createVNode(Select, {
                                width: 150,
                                title: locale.workerUseYn,
                                value: workerUseYn.value,
                                items: _unref(workerMonthlyAttendanceUseYnTypeOptionList),
                                "on-change": handleChangeUseYnSelector
                            }, null, 8 /* PROPS */, ["title", "value", "items"])
                        ]),
                        _createCommentVNode(" 초기화 "),
                        _createElementVNode("div", null, [
                            _createVNode(_component_v_btn, {
                                class: "brg-btn size-l outlined info",
                                variant: "text",
                                onClick: handleClickResetBtn
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                        icon: "mdi-restart",
                                        size: "16"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(locale.reset), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(SearchInputWrapper, null, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 검색 유형 "),
                                _createVNode(Select, {
                                    value: searchType.value,
                                    items: _unref(workerMonthlyAttendanceSearchTypeOptionList),
                                    "on-change": handleChangeSearchTypeSelector,
                                    class: "search-select"
                                }, null, 8 /* PROPS */, ["value", "items"]),
                                _createCommentVNode(" 검색어 "),
                                _createVNode(SearchInput, {
                                    placeholder: locale.searchPlaceholder,
                                    "on-search": handleChangeSearchKeyInput,
                                    "default-value": searchKey.value
                                }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createCommentVNode(" 페이지 사이즈 "),
                    _createCommentVNode(" <div class=\"right-filter-section\">\n        <Select\n          class=\"page-size-wrapper mini\"\n          :value=\"pageSize\"\n          :items=\"pageSizeOptionList\"\n          :on-change=\"handleChangePageSizeSelector\"\n        ></Select>\n      </div> ")
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
